'use client';

import { Fragment } from 'react';
import { Container } from '@/components/common/container';
import { FaqContent } from '@/app/(protected)/faq/content';

export default function FaqPageClient() {
  return (
    <Fragment>
      <Container>
        <FaqContent />
      </Container>
    </Fragment>
  );
}
